<template>
  <div class="topic-control-bar">
    
    <!-- Desktop View: Horizontal Links -->
    <div class="topic-tabs hidden-mobile">
      <a 
        v-for="topic in topics" 
        :key="topic.id"
        :href="topic.path"
        class="topic-link"
        :class="{ active: isTopicActive(topic) }"
        @click.prevent="handleNavigation(topic)"
      >
        {{ topic.label }}
      </a>
    </div>

    <!-- Mobile View: Custom Dropdown -->
    <div class="mobile-dropdown-wrapper hidden-desktop">
      
      <!-- The Button / Trigger -->
      <div class="dropdown-trigger" @click="toggleDropdown">
        <span class="trigger-text">{{ activeLabel }}</span>
        <span class="chevron" :class="{ rotated: isOpen }">
          <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
      </div>

      <!-- The Options List -->
      <div v-if="isOpen" class="dropdown-menu">
        <div 
          v-for="topic in topics" 
          :key="topic.id" 
          class="dropdown-item"
          :class="{ selected: isTopicActive(topic) }"
          @click="handleNavigation(topic)"
        >
          {{ topic.label }}
        </div>
      </div>

      <!-- Overlay to close when clicking outside -->
      <div v-if="isOpen" class="click-overlay" @click="isOpen = false"></div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'FeedSelector',
  props: {
    // Expected structure: [{ id: 'trending', label: 'Trending', path: '/trending' }]
    topics: {
      type: Array,
      default: () => [
        { id: 'trending', label: 'Trending', path: '/' },
        { id: 'replays', label: 'Replays', path: '/replays' }
      ]
    }
  },
  data() {
    return {
      isOpen: false,
      currentPath: ''
    };
  },
  mounted() {
    // Get initial path for active state
    this.currentPath = window.location.pathname;
  },
  computed: {
    activeLabel() {
      const active = this.topics.find(t => this.isTopicActive(t));
      return active ? active.label : 'Select Topic';
    }
  },
  methods: {
    isTopicActive(topic) {
      // specific match logic (you can change to .includes() if needed)
      return this.currentPath === topic.path;
    },
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    handleNavigation(topic) {
      this.isOpen = false; // Close dropdown if open
      
      // Navigate
      if (topic.path) {
        window.location.href = topic.path;
      }
      
      // Emit event just in case parent wants to know
      this.$emit('topic-selected', topic);
    }
  }
};
</script>

<style scoped>
/* --- Container --- */
.topic-control-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 10px 0;
  position: relative; /* Important for dropdown positioning */
}

/* --- Desktop Tabs --- */
.topic-link {
  text-decoration: none;
  color: #999;
  font-size: 16px;
  font-weight: 600;
  margin-left: 25px;
  padding-bottom: 5px;
  transition: color 0.2s ease;
  text-transform: capitalize;
  position: relative;
  font-family: sans-serif;
}

.topic-link:hover {
  color: #555;
}

.topic-link.active {
  color: #000;
  font-weight: 800;
}

.topic-link.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #000;
}

/* --- Mobile Custom Dropdown --- */
.mobile-dropdown-wrapper {
  position: relative;
  display: inline-block;
  z-index: 50; /* Ensure it sits above other content */
}

.dropdown-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  font-size: 16px;
  font-weight: 800; /* Bold like the active tab */
  color: #000;
  padding: 8px 0;
  user-select: none;
}

.trigger-text {
  margin-right: 8px;
}

.chevron {
  display: flex;
  align-items: center;
  transition: transform 0.2s ease;
  color: #000;
}

.chevron.rotated {
  transform: rotate(180deg);
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  min-width: 180px;
  background-color: #fff;
  border: 1px solid #eee;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 8px 0;
  margin-top: 4px;
  z-index: 100;
}

.dropdown-item {
  padding: 10px 16px;
  font-size: 15px;
  font-weight: 500;
  color: #666;
  cursor: pointer;
  transition: background-color 0.1s ease;
  text-align: left;
}

.dropdown-item:hover {
  background-color: #f9f9f9;
  color: #000;
}

.dropdown-item.selected {
  color: #000;
  font-weight: 800;
  background-color: #f5f5f5;
}

/* Overlay to handle clicking outside */
.click-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 40; /* Below dropdown, above page */
  cursor: default;
}

/* --- Responsive Logic --- */
.hidden-desktop { display: none; }
.hidden-mobile { display: flex; }

@media (max-width: 768px) {
  .hidden-desktop { display: block; }
  .hidden-mobile { display: none; }
  
  .topic-control-bar {
    width: 100%;
    justify-content: flex-end;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/site/FeedSelector.vue